export default function SpreedSheetIcon({
  width,
  height,
}: {
  width?: string;
  height?: string;
}) {
  return (
    <svg
      width={width ? width : "18"}
      height={height ? height : "18"}
      viewBox="0 0 18 18"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <g clipPath="url(#clip0_1493_3534)">
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M10.7019 0V5.09804H15.7999V17.3333H1.52539V0H10.7019ZM8.66366 12.2353H4.58421V13.2559H8.66366V12.2353ZM11.7215 10.1961H4.58421V11.2157H11.7215V10.1961ZM10.7019 8.15686H4.58421V9.17647H10.7019V8.15686ZM12.7411 6.11765H4.58421V7.13725H12.7411V6.11765ZM8.66366 4.07945H4.58421V5.09906H8.66366V4.07945Z"
          fill="currentColor"
        />
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M15.0548 3.12042C15.3291 3.39368 15.5228 3.72199 15.6472 4.07885H11.7207V0.152344C12.0776 0.276737 12.4059 0.471476 12.6802 0.744738L15.0548 3.12042Z"
          fill="currentColor"
        />
      </g>
      <defs>
        <clipPath id="clip0_1493_3534">
          <rect width="17.3333" height="17.3333" fill="white" />
        </clipPath>
      </defs>
    </svg>
  );
}
